import React from "react";
import { AvatarList } from "components/Common/AvatarList";
import { useGroupMembers } from "hooks/api/groups";

type GroupParticipantsCellProps = {
  groupId: number;
  memberIds: number[];
};

export const GroupParticipantsCell: React.FC<GroupParticipantsCellProps> = ({
  groupId,
  memberIds,
}) => {
  const { data: members, isLoading } = useGroupMembers(groupId);

  // Show loading state with count while fetching
  if (isLoading || !members) {
    return <AvatarList size="small" userData={memberIds.length} />;
  }

  // Show actual student data with photos
  return <AvatarList size="small" userData={members} />;
};
